import {SAMPLE_TYPES_CODES} from "../../../utils/constants";
import {BULK_META_TABLE, COMP_META_TABLE, HERD_META_TABLE, SOLO_META_TABLE} from "./table_constants";
import {GenerateDate, ToFullSampleTypeName} from "../../../utils/helpers";

export function GetMetaTable(reportType){
	switch(reportType){
		case SAMPLE_TYPES_CODES.solo:
			return SOLO_META_TABLE
		case SAMPLE_TYPES_CODES.bulk:
			return BULK_META_TABLE
		case SAMPLE_TYPES_CODES.comp:
			return COMP_META_TABLE
		case SAMPLE_TYPES_CODES.herd:
			return HERD_META_TABLE
		default:
			return Error('ERROR: Unknown report type')
	}
}

export const GenerateFilename = (reportType, dairyName) => {
	return `${ToFullSampleTypeName(reportType)}_${GenerateDate()}_${dairyName}`
}